import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { FileText, Coffee, Menu, X, MessageCircle } from 'lucide-react';
import ContactModal from './ContactModal';
import { portfolioData } from '../data/mock';

const Navigation = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);

  const handleDownloadResume = () => {
    // Show toast notification that resume download is currently disabled
    import('../hooks/use-toast').then(({ toast }) => {
      toast({
        title: "Resume Download Temporarily Unavailable",
        description: "Please contact me directly for my resume. Use the Contact Me button or reach out via LinkedIn.",
        duration: 5000,
      });
    });
    setMobileMenuOpen(false);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const openContactModal = () => {
    setContactModalOpen(true);
    setMobileMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/95 backdrop-blur-sm border-b border-slate-800">
      <div className="container mx-auto px-4 sm:px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link 
            to="/"
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            onClick={closeMobileMenu}
          >
            <h1 className="text-xl sm:text-2xl font-bold text-white cursor-pointer">Kushagra Bhatia</h1>
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-3">
            <Link to="/portfolio">
              <Button 
                variant="ghost" 
                className="text-slate-300 hover:text-white hover:bg-slate-800"
              >
                Portfolio
              </Button>
            </Link>
            <Button 
              variant="ghost" 
              className="text-slate-300 hover:text-white hover:bg-slate-800"
              onClick={openContactModal}
            >
              <MessageCircle size={18} className="mr-2" />
              Contact Me
            </Button>
            <Button 
              variant="ghost" 
              className="text-slate-300 hover:text-white hover:bg-slate-800"
              onClick={handleDownloadResume}
            >
              <FileText size={18} className="mr-2" />
              Download Resume
            </Button>
            <Link to="/coffee-chat">
              <Button 
                className="bg-blue-600 hover:bg-blue-700 text-white"
              >
                <Coffee size={18} className="mr-2" />
                Schedule Coffee Chat
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3">
            <Link to="/portfolio" onClick={closeMobileMenu}>
              <Button 
                variant="ghost" 
                className="w-full text-slate-300 hover:text-white hover:bg-slate-800 justify-start"
              >
                Portfolio
              </Button>
            </Link>
            <Button 
              variant="ghost" 
              className="w-full text-slate-300 hover:text-white hover:bg-slate-800 justify-start"
              onClick={openContactModal}
            >
              <MessageCircle size={18} className="mr-2" />
              Contact Me
            </Button>
            <Button 
              variant="ghost" 
              className="w-full text-slate-300 hover:text-white hover:bg-slate-800 justify-start"
              onClick={handleDownloadResume}
            >
              <FileText size={18} className="mr-2" />
              Download Resume
            </Button>
            <Link to="/coffee-chat" onClick={closeMobileMenu}>
              <Button 
                className="w-full bg-blue-600 hover:bg-blue-700 text-white justify-start"
              >
                <Coffee size={18} className="mr-2" />
                Schedule Coffee Chat
              </Button>
            </Link>
          </div>
        )}
      </div>
      
      {/* Contact Modal */}
      <ContactModal 
        isOpen={contactModalOpen} 
        onClose={() => setContactModalOpen(false)}
        portfolioData={portfolioData}
      />
    </nav>
  );
};

export default Navigation;
